module.exports = __webpack_public_path__ + "static/media/down_2.30d4dbbb.svg";